import React, { useEffect, useState } from "react";
import userSvg from "../assets/user.svg";
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";
import axios from "../helper/axios";
import { Modal } from "react-bootstrap";

const Profile = () => {
  const [userData, setUserData] = useState([]);
  const { logout, decodedToken, token } = React.useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenSupport, setIsOpenSupport] = useState(false);
  const [isOpenContact, setIsOpenContact] = useState(false);
  const [successBox, setSuccessBox] = useState(false);
  const [receiptData, setReceiptData] = useState([]);
  const [showPayment, setShowPayment] = useState(false);

  const [isError, setError] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  
  const [balance, setBalance] = useState(0);


  let orderId;
  let paymentWindow;

  const handlePayBalance = async (e) => {
    e.preventDefault();
    if (balance > userData?.balance) {
      setError("Amount is More Than Required");
      console.log("Amount is More Than Required");
      // alert("Amount is More Than Required");
      return;
    }
    if (balance == 0 || balance === null || balance === undefined) {
      setError("0 Not Allowed");
      console.log("0 Not Allowed");
      // alert("0 Not Allowed");
      return;
    }
    // console.log("Pay", parseInt(balance));

    if (!token) {
      navigate("/login");
    } else {
      setError("");
      try {
        const response = await axios.post(
          "receipt/payBalance",
          {
            amount: balance,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const { paymentUrl } = response.data.data;
        orderId = response.data.data.orderId;
        // console.log("responseData", response.data.data);

        paymentWindow = window.open(
          paymentUrl,
          "Payment Window",
          "width=1000,height=1000"
        );

        const checkPaymentStatus = async () => {
          try {
            const checkStatusResponse = await axios.post(
              "payment/paymentStatus",
              {
                orderId: orderId,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            const { orderStatus } = checkStatusResponse.data.data;
            // console.log("orderstatus", checkStatusResponse.data.data);

            // console.log("orderStatus & id", orderStatus, orderId);

            if (orderStatus === "SUCCESS") {
              console.log("Payment Success");
              setShowSuccessModal(true);
              setShowPaymentModal(false);
              if (showFailureModal) {
                setShowFailureModal(false);
              }
            } else if (orderStatus === "FAILED") {
              console.log("Payment failed");
              setShowFailureModal(true);
              setShowPaymentModal(false);
            } else if (orderStatus === "ACTIVE") {
              console.log("Payment Active");
              setShowPaymentModal(false);
            }
            fetchUserData();
            fetchReceiptData();
          } catch (error) {
            console.error("Error checking payment status", error);
          }
        };

        const checkWindowStatus = setInterval(() => {
          if (paymentWindow.closed) {
            clearInterval(checkWindowStatus);
            checkPaymentStatus();
          }
        }, 1000);
      } catch (error) {
        console.error("Error In Payment", error);
        setShowFailureModal(true);
        setShowPaymentModal(false);
      }
    }
  };

  const generateReceipt = async (e,receipt) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "receipt/print/"+receipt.receiptMasterId,
        {
          amount: balance,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      window.open(
        response.data.data.receiptFile?.filePath,
        "_blank"
      );

    } catch (error) {
      console.error("Error In Receipt Print", error);
    }

  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpen) {
      fetchUserData();
    }

  }, [isOpen]);

  const fetchUserData = async () => {
    try {
      const res = await axios.get("student/details", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserData(res.data.data);
    } catch (err) {
      console.error("Error Fetching User Data", err);
    }
  };

  const handleReceiptClick = () => {
    toggleDropdown();
    fetchShowPayment();
    fetchReceiptData();
  };

  const toggleDropdownSupport = () => {
    setIsOpenSupport(!isOpenSupport);
  };

  const toggleDropdownContact = () => {
    setIsOpenContact(!isOpenContact);
  };

  const toggleSuccessBox = (e) => {
    e.preventDefault();

    setSuccessBox(!successBox);

    document.querySelectorAll(".support-block.show").forEach((element) => {
      element.classList.remove("show");
    });

    document.querySelectorAll(".contact-block.show").forEach((element) => {
      element.classList.remove("show");
    });

    document.querySelectorAll(".success-block").forEach((element) => {
      element.classList.add("show");
    });
  };

  const closeModal = () => {
    document.querySelectorAll(".success-block.show").forEach((element) => {
      element.classList.remove("show");
    });
    // setSuccessBox(false);
  };

  const fetchReceiptData = async () => {
    try {
      const response = await axios.post(
        "receipt/list",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setReceiptData(response.data.data);
    } catch (error) {
      console.error("Error Fetching Receipt Data", error);
    }
  };

  const fetchShowPayment = async () => {
    try {
      const response = await axios.get(
        "receipt/show-payment",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setShowPayment(response.data.data);
    } catch (error) {
      console.error("Error Fetching Receipt Data", error);
    }
  };
  // console.log("receiptData", receiptData);

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();

    return `${day} ${month}, ${year}`;
  };
  return (
    <>
      <span className="col-1 text-end fw-bold">
        Hello, {decodedToken?.name?.split(" ")[0]}
      </span>

      <div className="col-1 text-center">
        <div className="btn-group dash-client-dropdown dropdown">
          <Link
            to="/dashboard"
            className="dropdown-toggle dash-client-img"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {decodedToken?.profilePicture?.filePath ? (
              <img
                style={{ borderRadius: "50%" }}
                src={decodedToken?.profilePicture?.filePath}
              />
            ) : (
              <img style={{ borderRadius: "50%" }} src={userSvg} />
            )}
          </Link>

          <ul className="dropdown-menu dropdown-menu-end">
            <li>
              <Link to="/my-profile">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M23 16C22.7348 16 22.4804 16.1054 22.2929 16.2929C22.1054 16.4804 22 16.7348 22 17V19C22 19.7956 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7956 22 19 22H17C16.7348 22 16.4804 22.1054 16.2929 22.2929C16.1054 22.4804 16 22.7348 16 23C16 23.2652 16.1054 23.5196 16.2929 23.7071C16.4804 23.8946 16.7348 24 17 24H19C20.3256 23.9984 21.5964 23.4711 22.5338 22.5338C23.4711 21.5964 23.9984 20.3256 24 19V17C24 16.7348 23.8946 16.4804 23.7071 16.2929C23.5196 16.1054 23.2652 16 23 16Z"
                    fill="#686D7B"
                  />
                  <path
                    d="M1 8C1.26522 8 1.51957 7.89464 1.70711 7.70711C1.89464 7.51957 2 7.26522 2 7V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H7C7.26522 2 7.51957 1.89464 7.70711 1.70711C7.89464 1.51957 8 1.26522 8 1C8 0.734784 7.89464 0.48043 7.70711 0.292893C7.51957 0.105357 7.26522 0 7 0L5 0C3.67441 0.00158786 2.40356 0.528882 1.46622 1.46622C0.528882 2.40356 0.00158786 3.67441 0 5L0 7C0 7.26522 0.105357 7.51957 0.292893 7.70711C0.48043 7.89464 0.734784 8 1 8Z"
                    fill="#686D7B"
                  />
                  <path
                    d="M7 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7956 2 19V17C2 16.7348 1.89464 16.4804 1.70711 16.2929C1.51957 16.1054 1.26522 16 1 16C0.734784 16 0.48043 16.1054 0.292893 16.2929C0.105357 16.4804 0 16.7348 0 17L0 19C0.00158786 20.3256 0.528882 21.5964 1.46622 22.5338C2.40356 23.4711 3.67441 23.9984 5 24H7C7.26522 24 7.51957 23.8946 7.70711 23.7071C7.89464 23.5196 8 23.2652 8 23C8 22.7348 7.89464 22.4804 7.70711 22.2929C7.51957 22.1054 7.26522 22 7 22Z"
                    fill="#686D7B"
                  />
                  <path
                    d="M19 0H17C16.7348 0 16.4804 0.105357 16.2929 0.292893C16.1054 0.48043 16 0.734784 16 1C16 1.26522 16.1054 1.51957 16.2929 1.70711C16.4804 1.89464 16.7348 2 17 2H19C19.7956 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V7C22 7.26522 22.1054 7.51957 22.2929 7.70711C22.4804 7.89464 22.7348 8 23 8C23.2652 8 23.5196 7.89464 23.7071 7.70711C23.8946 7.51957 24 7.26522 24 7V5C23.9984 3.67441 23.4711 2.40356 22.5338 1.46622C21.5964 0.528882 20.3256 0.00158786 19 0V0Z"
                    fill="#686D7B"
                  />
                  <path
                    d="M12 11C12.7911 11 13.5645 10.7654 14.2223 10.3259C14.8801 9.88635 15.3928 9.26164 15.6955 8.53074C15.9983 7.79983 16.0775 6.99556 15.9231 6.21964C15.7688 5.44372 15.3878 4.73098 14.8284 4.17157C14.269 3.61216 13.5563 3.2312 12.7804 3.07686C12.0044 2.92252 11.2002 3.00173 10.4693 3.30448C9.73836 3.60723 9.11365 4.11992 8.67412 4.77772C8.2346 5.43552 8 6.20888 8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11ZM12 5C12.3956 5 12.7822 5.1173 13.1111 5.33706C13.44 5.55683 13.6964 5.86918 13.8478 6.23463C13.9991 6.60009 14.0387 7.00222 13.9616 7.39018C13.8844 7.77814 13.6939 8.13451 13.4142 8.41422C13.1345 8.69392 12.7781 8.8844 12.3902 8.96157C12.0022 9.03874 11.6001 8.99914 11.2346 8.84776C10.8692 8.69639 10.5568 8.44004 10.3371 8.11114C10.1173 7.78224 10 7.39556 10 7C10 6.46957 10.2107 5.96086 10.5858 5.58579C10.9609 5.21072 11.4696 5 12 5Z"
                    fill="#686D7B"
                  />
                  <path
                    d="M18 20C18.2652 20 18.5196 19.8946 18.7071 19.7071C18.8946 19.5196 19 19.2652 19 19C18.9984 17.4092 18.3658 15.884 17.2409 14.7591C16.116 13.6342 14.5908 13.0016 13 13H11C9.40919 13.0016 7.88399 13.6342 6.75911 14.7591C5.63424 15.884 5.00159 17.4092 5 19C5 19.2652 5.10536 19.5196 5.29289 19.7071C5.48043 19.8946 5.73478 20 6 20C6.26522 20 6.51957 19.8946 6.70711 19.7071C6.89464 19.5196 7 19.2652 7 19C7 17.9391 7.42143 16.9217 8.17157 16.1716C8.92172 15.4214 9.93913 15 11 15H13C14.0609 15 15.0783 15.4214 15.8284 16.1716C16.5786 16.9217 17 17.9391 17 19C17 19.2652 17.1054 19.5196 17.2929 19.7071C17.4804 19.8946 17.7348 20 18 20Z"
                    fill="#686D7B"
                  />
                </svg>

                <span>Edit Profile</span>
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-link"
                onClick={() => handleReceiptClick()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="27"
                  viewBox="0 0 20 27"
                  fill="none"
                >
                  <path
                    d="M14.4444 0H5.55556C4.08267 0.00176429 2.67062 0.587647 1.62913 1.62913C0.587647 2.67062 0.00176429 4.08267 0 5.55556V25.5556C0.00015654 25.7577 0.0554294 25.9559 0.159868 26.1289C0.264307 26.3019 0.413957 26.4432 0.592709 26.5375C0.77146 26.6318 0.972543 26.6755 1.17431 26.664C1.37608 26.6525 1.57089 26.5862 1.73778 26.4722L4.07778 24.8733L6.41778 26.4722C6.60265 26.5988 6.82149 26.6666 7.04556 26.6666C7.26962 26.6666 7.48846 26.5988 7.67333 26.4722L10.0067 24.8733L12.34 26.4722C12.525 26.5991 12.744 26.6669 12.9683 26.6669C13.1926 26.6669 13.4117 26.5991 13.5967 26.4722L15.93 24.8744L18.2633 26.4711C18.4301 26.5847 18.6247 26.6508 18.8262 26.6622C19.0277 26.6736 19.2285 26.6298 19.4071 26.5357C19.5856 26.4416 19.7351 26.3006 19.8396 26.1279C19.944 25.9553 19.9995 25.7574 20 25.5556V5.55556C19.9982 4.08267 19.4124 2.67062 18.3709 1.62913C17.3294 0.587647 15.9173 0.00176429 14.4444 0V0ZM17.7778 23.4444L16.5556 22.6089C16.3705 22.4818 16.1512 22.4138 15.9267 22.4138C15.7021 22.4138 15.4829 22.4818 15.2978 22.6089L12.9644 24.2078L10.6311 22.6089C10.4461 22.482 10.2271 22.4142 10.0028 22.4142C9.77848 22.4142 9.55943 22.482 9.37444 22.6089L7.04111 24.2078L4.70778 22.6089C4.52301 22.4825 4.30439 22.4149 4.08056 22.4149C3.85672 22.4149 3.6381 22.4825 3.45333 22.6089L2.22222 23.4444V5.55556C2.22222 4.6715 2.57341 3.82365 3.19853 3.19853C3.82365 2.57341 4.6715 2.22222 5.55556 2.22222H14.4444C15.3285 2.22222 16.1763 2.57341 16.8015 3.19853C17.4266 3.82365 17.7778 4.6715 17.7778 5.55556V23.4444Z"
                    fill="#686D7B"
                  />
                  <path
                    d="M14.4453 8.88867H5.55642C4.94277 8.88867 4.44531 9.38613 4.44531 9.99978C4.44531 10.6134 4.94277 11.1109 5.55642 11.1109H14.4453C15.059 11.1109 15.5564 10.6134 15.5564 9.99978C15.5564 9.38613 15.059 8.88867 14.4453 8.88867Z"
                    fill="#686D7B"
                  />
                  <path
                    d="M12.2231 13.333H5.55642C4.94277 13.333 4.44531 13.8305 4.44531 14.4441C4.44531 15.0578 4.94277 15.5552 5.55642 15.5552H12.2231C12.8367 15.5552 13.3342 15.0578 13.3342 14.4441C13.3342 13.8305 12.8367 13.333 12.2231 13.333Z"
                    fill="#686D7B"
                  />
                </svg>

                <span>Receipt</span>
              </Link>
            </li>
            <li>
              <Link to="/aboutus">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                >
                  <path
                    d="M13 0C10.4288 0 7.91543 0.762437 5.77759 2.19089C3.63975 3.61935 1.97351 5.64967 0.989572 8.02511C0.00563272 10.4006 -0.251811 13.0144 0.249797 15.5362C0.751405 18.0579 1.98953 20.3743 3.80762 22.1924C5.6257 24.0105 7.94208 25.2486 10.4638 25.7502C12.9856 26.2518 15.5994 25.9944 17.9749 25.0104C20.3503 24.0265 22.3806 22.3602 23.8091 20.2224C25.2376 18.0846 26 15.5712 26 13C25.9963 9.55333 24.6254 6.24889 22.1883 3.81173C19.7511 1.37456 16.4467 0.00372784 13 0V0ZM13 23.8333C10.8574 23.8333 8.76286 23.198 6.98133 22.0076C5.19979 20.8172 3.81126 19.1253 2.99131 17.1457C2.17136 15.1662 1.95683 12.988 2.37483 10.8865C2.79284 8.78506 3.82461 6.85474 5.33968 5.33968C6.85475 3.82461 8.78507 2.79283 10.8865 2.37483C12.988 1.95682 15.1662 2.17136 17.1457 2.9913C19.1253 3.81125 20.8172 5.19979 22.0076 6.98132C23.198 8.76285 23.8333 10.8574 23.8333 13C23.8302 15.8722 22.6878 18.6259 20.6568 20.6568C18.6259 22.6878 15.8722 23.8302 13 23.8333Z"
                    fill="#686D7B"
                  />
                  <path
                    d="M12.9987 10.833H11.9154C11.628 10.833 11.3525 10.9471 11.1493 11.1503C10.9462 11.3535 10.832 11.629 10.832 11.9163C10.832 12.2037 10.9462 12.4792 11.1493 12.6824C11.3525 12.8855 11.628 12.9997 11.9154 12.9997H12.9987V19.4997C12.9987 19.787 13.1128 20.0625 13.316 20.2657C13.5192 20.4689 13.7947 20.583 14.082 20.583C14.3693 20.583 14.6449 20.4689 14.8481 20.2657C15.0512 20.0625 15.1654 19.787 15.1654 19.4997V12.9997C15.1654 12.425 14.9371 11.8739 14.5308 11.4676C14.1244 11.0613 13.5733 10.833 12.9987 10.833Z"
                    fill="#686D7B"
                  />
                  <path
                    d="M13 8.66699C13.8975 8.66699 14.625 7.93946 14.625 7.04199C14.625 6.14453 13.8975 5.41699 13 5.41699C12.1025 5.41699 11.375 6.14453 11.375 7.04199C11.375 7.93946 12.1025 8.66699 13 8.66699Z"
                    fill="#686D7B"
                  />
                </svg>

                <span>About Pride Educare</span>
              </Link>
            </li>
            <li>
              <Link
                to="/"
                className="dropdown-link"
                onClick={toggleDropdownSupport}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="20"
                  viewBox="0 0 24 20"
                  fill="none"
                >
                  <path
                    d="M20.9851 10.424V9C20.9851 6.61305 20.0368 4.32387 18.349 2.63604C16.6612 0.948212 14.372 0 11.9851 0C9.59811 0 7.30892 0.948212 5.6211 2.63604C3.93327 4.32387 2.98506 6.61305 2.98506 9V10.424C1.93622 10.8858 1.07786 11.694 0.55368 12.7131C0.0295007 13.7322 -0.128681 14.9004 0.105616 16.0222C0.339912 17.1441 0.952465 18.1513 1.84073 18.8755C2.72899 19.5996 3.83904 19.9966 4.98506 20C5.51549 20 6.0242 19.7893 6.39927 19.4142C6.77434 19.0391 6.98506 18.5304 6.98506 18V12C6.98506 11.4696 6.77434 10.9609 6.39927 10.5858C6.0242 10.2107 5.51549 10 4.98506 10V9C4.98506 7.14348 5.72256 5.36301 7.03531 4.05025C8.34806 2.7375 10.1285 2 11.9851 2C13.8416 2 15.6221 2.7375 16.9348 4.05025C18.2476 5.36301 18.9851 7.14348 18.9851 9V10C18.4546 10 17.9459 10.2107 17.5708 10.5858C17.1958 10.9609 16.9851 11.4696 16.9851 12V18H13.9851C13.7198 18 13.4655 18.1054 13.278 18.2929C13.0904 18.4804 12.9851 18.7348 12.9851 19C12.9851 19.2652 13.0904 19.5196 13.278 19.7071C13.4655 19.8946 13.7198 20 13.9851 20H18.9851C20.1311 19.9966 21.2411 19.5996 22.1294 18.8755C23.0176 18.1513 23.6302 17.1441 23.8645 16.0222C24.0988 14.9004 23.9406 13.7322 23.4164 12.7131C22.8923 11.694 22.0339 10.8858 20.9851 10.424ZM4.98506 18C4.18941 18 3.42635 17.6839 2.86374 17.1213C2.30113 16.5587 1.98506 15.7956 1.98506 15C1.98506 14.2044 2.30113 13.4413 2.86374 12.8787C3.42635 12.3161 4.18941 12 4.98506 12V18ZM18.9851 18V12C19.7807 12 20.5438 12.3161 21.1064 12.8787C21.669 13.4413 21.9851 14.2044 21.9851 15C21.9851 15.7956 21.669 16.5587 21.1064 17.1213C20.5438 17.6839 19.7807 18 18.9851 18Z"
                    fill="#686D7B"
                  />
                </svg>
                <span>Support</span>
              </Link>
            </li>
            <li>
              <Link
                to="/"
                className="dropdown-link"
                onClick={toggleDropdownContact}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="22"
                  viewBox="0 0 26 22"
                  fill="none"
                >
                  <path
                    d="M20 1.00445H6C4.73576 0.950022 3.50117 1.3968 2.5648 2.24758C1.62844 3.09836 1.06605 4.28431 1 5.54743V16.4526C1.06605 17.7157 1.62844 18.9016 2.5648 19.7524C3.50117 20.6032 4.73576 21.05 6 20.9956H20C21.2642 21.05 22.4988 20.6032 23.4352 19.7524C24.3716 18.9016 24.9339 17.7157 25 16.4526V5.54743C24.9339 4.28431 24.3716 3.09836 23.4352 2.24758C22.4988 1.3968 21.2642 0.950022 20 1.00445ZM6 2.82164H20C20.5792 2.80986 21.1496 2.96532 21.6427 3.26937C22.1358 3.57342 22.5306 4.01316 22.78 4.53588L15.122 11.4998C14.5344 12.0132 13.7805 12.2962 13 12.2962C12.2195 12.2962 11.4656 12.0132 10.878 11.4998L3.22 4.53688C3.46921 4.01397 3.86404 3.57402 4.35713 3.26979C4.85023 2.96555 5.42065 2.80995 6 2.82164ZM20 19.1784H6C5.24098 19.2129 4.49919 18.9454 3.93695 18.4346C3.37472 17.9238 3.03783 17.2111 3 16.4526V6.91082L9.464 12.7812C10.4427 13.6377 11.6992 14.1098 13 14.1098C14.3008 14.1098 15.5573 13.6377 16.536 12.7812L23 6.91082V16.4516C22.9624 17.2103 22.6256 17.9232 22.0634 18.4342C21.5011 18.9453 20.7592 19.2129 20 19.1784Z"
                    fill="#686D7B"
                    stroke="#686D7B"
                    strokeWidth="0.2"
                  />
                </svg>
                <span>Contact Us</span>
              </Link>
            </li>
            {/* <li>
              <Link to="/">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="27"
                  viewBox="0 0 25 27"
                  fill="none"
                >
                  <path
                    d="M22.6578 17.4649L22.6172 17.4358C22.9627 16.9535 23.6339 16.8422 24.1165 17.1877C24.5992 17.5332 24.7102 18.2044 24.3648 18.687L19.2938 25.7704L19.2938 25.7704L19.2531 25.7413C19.2421 25.7567 19.2305 25.7719 19.2187 25.7865L22.6578 17.4649ZM22.6578 17.4649L22.6172 17.4358L17.568 24.4888C17.4423 24.6333 17.2854 24.6647 17.2007 24.6704L22.6578 17.4649ZM10.9903 26.821C11.5839 26.821 12.0649 26.3399 12.0649 25.7463C12.0649 25.1528 11.5839 24.6717 10.9903 24.6717H5.09858C3.99628 24.6717 3.09929 23.7747 3.09929 22.6724V4.63862C3.09929 3.53632 3.99628 2.63933 5.09858 2.63933H17.6961C18.7984 2.63933 19.6954 3.53632 19.6954 4.63862V15.4999C19.6954 16.0934 20.1765 16.5745 20.7701 16.5745C21.3634 16.5745 21.8447 16.0934 21.8447 15.4999V4.63862C21.8447 2.35098 19.9836 0.490039 17.6961 0.490039H5.09858C2.81094 0.490039 0.95 2.35098 0.95 4.63862V22.6724C0.95 24.96 2.81094 26.821 5.09858 26.821H10.9903ZM16.6715 6.63791H6.11763C5.52405 6.63791 5.04298 7.11899 5.04298 7.71256C5.04298 8.30613 5.52405 8.7872 6.11763 8.7872H16.6715C17.2648 8.7872 17.7461 8.30614 17.7461 7.71256C17.7461 7.11898 17.2648 6.63791 16.6715 6.63791ZM17.7461 11.8111C17.7461 11.2176 17.2648 10.7365 16.6715 10.7365H6.11763C5.52405 10.7365 5.04298 11.2176 5.04298 11.8111C5.04298 12.4047 5.52405 12.8858 6.11763 12.8858H16.6715C17.2648 12.8858 17.7461 12.4047 17.7461 11.8111ZM6.11763 14.8351C5.52405 14.8351 5.04298 15.3162 5.04298 15.9097C5.04298 16.5033 5.52405 16.9844 6.11763 16.9844H12.5273C13.1208 16.9844 13.6019 16.5033 13.6019 15.9097C13.6019 15.3162 13.1208 14.8351 12.5273 14.8351H6.11763Z"
                    fill="#686D7B"
                    stroke="#686D7B"
                    strokeWidth="0.1"
                  />
                </svg>

                <span>My Certificates</span>
              </Link>
            </li> */}
            <li>
              <Link to="/" onClick={logout}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M14 5L12.6 6.4L14.2 8H6V10H14.2L12.6 11.6L14 13L18 9L14 5ZM2 2H9V0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H9V16H2V2Z"
                    fill="#686D7B"
                  />
                </svg>
                <span>Logout</span>
              </Link>
            </li>
          </ul>
        </div>

        <div className={`receipt-block success-block`}>
          <div className="success-tick-block">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="93"
              height="93"
              viewBox="0 0 93 93"
              fill="none"
            >
              <g clipPath="url(#clip0_727_17414)">
                <path
                  d="M46.5 93C72.1812 93 93 72.1812 93 46.5C93 20.8188 72.1812 0 46.5 0C20.8188 0 0 20.8188 0 46.5C0 72.1812 20.8188 93 46.5 93Z"
                  fill="#6487C9"
                />
                <path
                  d="M34.6172 67.4763L58.5273 91.3864C78.3301 86.1056 92.9989 68.063 92.9989 46.4999C92.9989 46.0599 92.9989 45.6198 92.9989 45.1798L74.2229 27.8706L34.6172 67.4763Z"
                  fill="#466EB6"
                />
                <path
                  d="M47.6724 56.9149C49.726 58.9685 49.726 62.489 47.6724 64.5427L43.4184 68.7966C41.3648 70.8502 37.8443 70.8502 35.7907 68.7966L17.1613 50.0206C15.1077 47.9669 15.1077 44.4464 17.1613 42.3928L21.4153 38.1389C23.4689 36.0852 26.9894 36.0852 29.043 38.1389L47.6724 56.9149Z"
                  fill="white"
                />
                <path
                  d="M63.956 24.4969C66.0097 22.4433 69.5302 22.4433 71.5838 24.4969L75.8377 28.7508C77.8914 30.8045 77.8914 34.325 75.8377 36.3786L43.5665 68.5032C41.5128 70.5568 37.9923 70.5568 35.9387 68.5032L31.6848 64.2492C29.6311 62.1956 29.6311 58.6751 31.6848 56.6215L63.956 24.4969Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_727_17414">
                  <rect width="93" height="93" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="53"
              height="25"
              viewBox="0 0 53 25"
              fill="none"
              className="blue-triangle"
            >
              <path
                d="M24.6814 23.6119C25.7559 24.4317 27.2459 24.4317 28.3205 23.6119L51.0863 6.24485C53.3686 4.50375 52.1373 0.859646 49.2667 0.859646H3.73516C0.864535 0.859646 -0.36674 4.50374 1.9156 6.24484L24.6814 23.6119Z"
                fill="#DDEEFD"
              />
            </svg>
          </div>
          <div className="success-text-block">
            <div className="course-title">
              Your Request has been sent successfully
            </div>

            <div className="section-content">
              We will revert back to you within few working days...!
            </div>

            <div className="btn-list text-center">
              <Link className="support-btn" onClick={closeModal}>
                Close
              </Link>
            </div>
          </div>
        </div>

        <div
          className={`receipt-block dropdown-list support-block ${isOpenSupport ? "show" : ""
            }`}
        >
          <h3>
            <svg
              onClick={toggleDropdownSupport}
              className="right-arraow"
              xmlns="http://www.w3.org/2000/svg"
              width="110"
              height="110"
              viewBox="0 0 110 110"
              fill="none"
            >
              <path
                d="M105 5L5 105M5 5L105 105"
                stroke="#686D7B"
                strokeWidth="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Support
          </h3>
          <div>
            <textarea
              name=""
              className="card-shadow support-textarea"
              id=""
              cols="30"
              rows="8"
              required
            ></textarea>

            <div className="btn-list">
              <Link className="support-btn" onClick={toggleSuccessBox}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M22.6704 10.0911L22.6704 10.0911L4.03858 0.840706C4.03856 0.840696 4.03854 0.840685 4.03852 0.840674C2.73383 0.19218 1.16669 0.753354 0.53718 2.08651L0.537177 2.08652C0.216618 2.76547 0.189711 3.55127 0.462988 4.25149C0.462994 4.25151 0.462999 4.25152 0.463005 4.25154L3.6816 12.5058L0.462986 20.7609L0.462856 20.7612C-0.0703864 22.1386 0.584181 23.7024 1.93277 24.252C2.23773 24.3763 2.56282 24.4409 2.89118 24.4424H2.89187C3.28906 24.4424 3.68099 24.3504 4.03837 24.1735L4.03853 24.1734L22.6703 14.9204L22.6703 14.9204C23.9729 14.2731 24.5138 12.6685 23.8854 11.3373C23.629 10.7942 23.2012 10.3549 22.6704 10.0911ZM3.18816 22.3819L3.18813 22.382C2.85627 22.5468 2.45417 22.4061 2.29095 22.0601L2.29094 22.0601C2.20763 21.8836 2.20064 21.6789 2.27182 21.4966L2.27185 21.4965L5.38887 13.5003H21.0776L3.18816 22.3819ZM3.18817 2.63212L21.0775 11.5112H5.38891L2.2719 3.51499L2.27191 3.51498L2.27107 3.51292C2.16301 3.24743 2.23071 2.94158 2.43726 2.75061L2.43734 2.7507L2.44149 2.74655C2.64054 2.54755 2.93937 2.50175 3.18522 2.63061L3.18521 2.63064L3.18817 2.63212Z"
                    fill="white"
                    stroke="white"
                    strokeWidth="0.3"
                  />
                  <line
                    x1="22.0992"
                    y1="11.2277"
                    x2="22.0992"
                    y2="14.3822"
                    stroke="white"
                    strokeWidth="0.3"
                  />
                  <line
                    x1="21.9492"
                    y1="12.322"
                    x2="22.4616"
                    y2="12.322"
                    stroke="white"
                    strokeWidth="0.3"
                  />
                  <line
                    x1="21.8961"
                    y1="11.2277"
                    x2="21.8961"
                    y2="13.3307"
                    stroke="white"
                    strokeWidth="0.3"
                  />
                </svg>{" "}
                Send
              </Link>
            </div>
          </div>
        </div>

        <div className={`dropdown-list receipt-block ${isOpen ? "show" : ""}`}>
          <h3>
            <svg
              onClick={toggleDropdown}
              className="right-arraow"
              xmlns="http://www.w3.org/2000/svg"
              width="110"
              height="110"
              viewBox="0 0 110 110"
              fill="none"
            >
              <path
                d="M105 5L5 105M5 5L105 105"
                stroke="#686D7B"
                strokeWidth="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Receipt
          </h3>
          <div className="row" style={{ marginLeft: "0" }}>
            <div className="col-4">
              <div className="pt-1">
                <p className="mb-1"> <b> Total Paid</b></p>
                <p className="mb-1">{userData?.totalPaid}</p>
              </div>
            </div>
            <div className="col-4">
              <div className="pt-1">
                <p className="mb-1"> <b> Balance</b></p>
                <p className="mb-1">{userData?.balance}</p>
              </div>
            </div>
            <div className="col-4">
              <div className="pt-1">
                <p className="mb-1"> <b> Total Payable</b></p>
                <p className="mb-1">{userData?.totalPayable}</p>
              </div>
            </div>
          </div>
          <ul>
            {
              userData && userData.balance > 0 && showPayment && 
              <button className="btn btn-primary mb-3" onClick={() => setShowPaymentModal(true)}>Pay Now</button>}
            {receiptData?.list?.map((receipt, index) => (
              <>
                <li key={receipt.receiptMasterId}>
                  <Link
                    // download={receipt.receiptFile?.filePath}
                    // target="_blank"
                    // rel="noreferrer"
                    onClick={(e) => generateReceipt(e,receipt)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="43"
                      height="39"
                      viewBox="0 0 43 39"
                      fill="none"
                    >
                      <path
                        d="M26.6489 38.1498C25.9533 38.1511 25.2642 38.0229 24.6208 37.7727C23.9786 37.5228 23.3944 37.156 22.9017 36.6929L20.2682 34.4848L20.3645 34.3698L20.2681 34.4848C20.0856 34.3317 19.9364 34.1458 19.8293 33.9374C19.7223 33.729 19.6597 33.5023 19.6454 33.2704C19.6165 32.8016 19.7866 32.3429 20.1155 31.9948C20.444 31.6472 20.9038 31.4383 21.393 31.4116C21.6354 31.3983 21.8783 31.4301 22.108 31.5054C22.3376 31.5806 22.5499 31.6979 22.7323 31.851L22.7326 31.8512L24.7659 33.5646V21.9094C24.7659 21.4399 24.9639 20.9916 25.3132 20.6624C25.6622 20.3336 26.1338 20.1503 26.6237 20.1503C27.1136 20.1503 27.5852 20.3336 27.9342 20.6624C28.2835 20.9916 28.4815 21.4399 28.4815 21.9094V33.5665L30.5149 31.856L30.5151 31.8558C30.8831 31.5472 31.3643 31.3899 31.8531 31.4163C32.3418 31.4428 32.8014 31.6509 33.1301 31.9979C33.2933 32.1701 33.4193 32.3713 33.5004 32.5904C33.5816 32.8096 33.6162 33.0419 33.6021 33.274C33.588 33.5061 33.5254 33.733 33.4184 33.9417C33.3113 34.1503 33.1619 34.3364 32.9793 34.4896M26.6489 38.1498C26.6486 38.1498 26.6484 38.1498 26.6482 38.1498L26.6493 37.9998L26.6496 38.1498C26.6494 38.1498 26.6491 38.1498 26.6489 38.1498ZM26.6489 38.1498C27.3202 38.1549 27.9862 38.0349 28.6085 37.7966C29.2299 37.5586 29.7958 37.2073 30.2737 36.7622M30.2737 36.7622L32.9793 34.4896M30.2737 36.7622C30.2747 36.7613 30.2756 36.7604 30.2766 36.7595L30.1743 36.6499M30.2737 36.7622L30.2707 36.7647L30.1743 36.6499M32.9793 34.4896L32.9794 34.4895L32.8829 34.3747M32.9793 34.4896L32.8829 34.3747M32.8829 34.3747L30.1743 36.6499M32.8829 34.3747L30.1743 36.6499M5.82644 19.6705C4.13757 20.527 2.76249 21.8489 1.8871 23.463C0.986895 25.1229 0.660845 27.0076 0.955583 28.852L0.955398 28.852L0.956951 28.8593C1.40963 30.9993 2.62525 32.9271 4.39962 34.3237C6.17383 35.7202 8.40038 36.5019 10.7094 36.5408H10.7119H14.6689C15.1589 36.5408 15.6304 36.3575 15.9794 36.0287C16.3287 35.6996 16.5268 35.2513 16.5268 34.7818C16.5268 34.3122 16.3287 33.8639 15.9794 33.5348C15.6304 33.206 15.1589 33.0227 14.6689 33.0227H10.7132C9.28652 32.9966 7.91157 32.5197 6.80886 31.67C5.70739 30.8212 4.94181 29.6501 4.63243 28.3454C4.45378 27.2273 4.65044 26.0842 5.19579 25.0757C5.7421 24.0653 6.61141 23.2399 7.68314 22.7168L7.68316 22.7168L7.68662 22.715C8.50351 22.2897 9.11243 21.5768 9.37836 20.7285C9.64434 19.88 9.54482 18.9671 9.10238 18.1882C8.44999 17.0157 8.0651 15.7281 7.972 14.4081C7.87889 13.0878 8.07968 11.7636 8.56172 10.5203C9.04378 9.27696 9.7966 8.14161 10.7725 7.18734C11.7483 6.23305 12.9257 5.48097 14.2293 4.97982C15.5328 4.47866 16.9335 4.23965 18.3413 4.27833C19.7491 4.317 21.1325 4.63249 22.4028 5.20429C23.673 5.77608 24.8016 6.59141 25.7167 7.59749C26.6317 8.60353 27.313 9.7781 27.7173 11.0456L27.7175 11.0465C27.9782 11.8476 28.4424 12.5758 29.0688 13.168C29.6952 13.7601 30.4648 14.1985 31.3106 14.4458L31.3113 14.446C33.5111 15.0767 35.4131 16.3981 36.7017 18.188C37.99 19.9776 38.5877 22.128 38.3966 24.2807L38.3964 24.2827C38.2702 25.9536 37.6222 27.553 36.5327 28.8795L36.5324 28.8799C36.2306 29.2498 36.096 29.7193 36.1607 30.1848C36.2253 30.6502 36.4832 31.0698 36.874 31.3529C37.2646 31.6357 37.7569 31.7599 38.2429 31.7C38.7289 31.6401 39.172 31.4005 39.4735 31.031L39.4736 31.0308C40.9968 29.1597 41.9107 26.9107 42.1026 24.5574C42.3636 21.6018 41.5412 18.652 39.7741 16.2001C38.0072 13.7483 35.4029 11.9429 32.3968 11.0828C32.1263 11.0036 31.8817 10.8628 31.6845 10.6736C31.4872 10.4844 31.3435 10.2528 31.2654 10L31.2655 10L31.2645 9.99721C30.3492 7.22855 28.4804 4.82856 25.956 3.17595C23.4318 1.52343 20.3957 0.712081 17.3284 0.869182C14.261 1.02628 11.3358 2.14297 9.01606 4.04397C6.69627 5.94503 5.11432 8.52222 4.52282 11.3684C3.92655 14.1967 4.38866 17.1302 5.82644 19.6705Z"
                        fill="white"
                        stroke="white"
                        strokeWidth="0.3"
                      />
                    </svg>

                    <div className="course-details">
                      <h4 className="course-title">
                        {receipt.receiptNo}
                      </h4>
                      <ul className="course-detail-list">
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z"
                              fill="#BBBBBB"
                            />
                            <path
                              d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z"
                              fill="#BBBBBB"
                            />
                            <path
                              d="M4.66797 11C5.22025 11 5.66797 10.5523 5.66797 10C5.66797 9.44772 5.22025 9 4.66797 9C4.11568 9 3.66797 9.44772 3.66797 10C3.66797 10.5523 4.11568 11 4.66797 11Z"
                              fill="#BBBBBB"
                            />
                            <path
                              d="M11.332 11C11.8843 11 12.332 10.5523 12.332 10C12.332 9.44772 11.8843 9 11.332 9C10.7797 9 10.332 9.44772 10.332 10C10.332 10.5523 10.7797 11 11.332 11Z"
                              fill="#BBBBBB"
                            />
                          </svg>
                          {formatDate(receipt.receiptDate)}
                        </li>
                        <li>
                          <svg
                            width="11"
                            height="14"
                            viewBox="0 0 11 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.532 3.316V3.568H10.62V5.044H8.424C8.292 5.848 8.04 6.49 7.668 6.97C7.308 7.438 6.792 7.78 6.12 7.996C5.448 8.2 4.578 8.302 3.51 8.302V9.436C3.51 10.096 3.648 10.618 3.924 11.002C4.212 11.386 4.692 11.578 5.364 11.578C6.588 11.578 7.2 10.888 7.2 9.508H9.09C9.078 10.72 8.748 11.638 8.1 12.262C7.464 12.874 6.54 13.18 5.328 13.18C4.116 13.18 3.186 12.844 2.538 12.172C1.902 11.5 1.584 10.558 1.584 9.346V6.88C2.916 6.88 3.894 6.844 4.518 6.772C5.142 6.688 5.604 6.52 5.904 6.268C6.216 6.016 6.42 5.608 6.516 5.044H0.828V3.568H6.606V3.316V1.966H0.828V0.471999H10.62V1.966H8.532V3.316Z"
                              fill="#BBBBBB"
                            />
                          </svg>
                          {receipt.amount}
                        </li>
                      </ul>
                    </div>
                  </Link>
                </li>
              </>
            ))}

            {/* <li>
              <Link
                download="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20210101201653/PDF.pdf"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="43"
                  height="39"
                  viewBox="0 0 43 39"
                  fill="none"
                >
                  <path
                    d="M26.6489 38.1498C25.9533 38.1511 25.2642 38.0229 24.6208 37.7727C23.9786 37.5228 23.3944 37.156 22.9017 36.6929L20.2682 34.4848L20.3645 34.3698L20.2681 34.4848C20.0856 34.3317 19.9364 34.1458 19.8293 33.9374C19.7223 33.729 19.6597 33.5023 19.6454 33.2704C19.6165 32.8016 19.7866 32.3429 20.1155 31.9948C20.444 31.6472 20.9038 31.4383 21.393 31.4116C21.6354 31.3983 21.8783 31.4301 22.108 31.5054C22.3376 31.5806 22.5499 31.6979 22.7323 31.851L22.7326 31.8512L24.7659 33.5646V21.9094C24.7659 21.4399 24.9639 20.9916 25.3132 20.6624C25.6622 20.3336 26.1338 20.1503 26.6237 20.1503C27.1136 20.1503 27.5852 20.3336 27.9342 20.6624C28.2835 20.9916 28.4815 21.4399 28.4815 21.9094V33.5665L30.5149 31.856L30.5151 31.8558C30.8831 31.5472 31.3643 31.3899 31.8531 31.4163C32.3418 31.4428 32.8014 31.6509 33.1301 31.9979C33.2933 32.1701 33.4193 32.3713 33.5004 32.5904C33.5816 32.8096 33.6162 33.0419 33.6021 33.274C33.588 33.5061 33.5254 33.733 33.4184 33.9417C33.3113 34.1503 33.1619 34.3364 32.9793 34.4896M26.6489 38.1498C26.6486 38.1498 26.6484 38.1498 26.6482 38.1498L26.6493 37.9998L26.6496 38.1498C26.6494 38.1498 26.6491 38.1498 26.6489 38.1498ZM26.6489 38.1498C27.3202 38.1549 27.9862 38.0349 28.6085 37.7966C29.2299 37.5586 29.7958 37.2073 30.2737 36.7622M30.2737 36.7622L32.9793 34.4896M30.2737 36.7622C30.2747 36.7613 30.2756 36.7604 30.2766 36.7595L30.1743 36.6499M30.2737 36.7622L30.2707 36.7647L30.1743 36.6499M32.9793 34.4896L32.9794 34.4895L32.8829 34.3747M32.9793 34.4896L32.8829 34.3747M32.8829 34.3747L30.1743 36.6499M32.8829 34.3747L30.1743 36.6499M5.82644 19.6705C4.13757 20.527 2.76249 21.8489 1.8871 23.463C0.986895 25.1229 0.660845 27.0076 0.955583 28.852L0.955398 28.852L0.956951 28.8593C1.40963 30.9993 2.62525 32.9271 4.39962 34.3237C6.17383 35.7202 8.40038 36.5019 10.7094 36.5408H10.7119H14.6689C15.1589 36.5408 15.6304 36.3575 15.9794 36.0287C16.3287 35.6996 16.5268 35.2513 16.5268 34.7818C16.5268 34.3122 16.3287 33.8639 15.9794 33.5348C15.6304 33.206 15.1589 33.0227 14.6689 33.0227H10.7132C9.28652 32.9966 7.91157 32.5197 6.80886 31.67C5.70739 30.8212 4.94181 29.6501 4.63243 28.3454C4.45378 27.2273 4.65044 26.0842 5.19579 25.0757C5.7421 24.0653 6.61141 23.2399 7.68314 22.7168L7.68316 22.7168L7.68662 22.715C8.50351 22.2897 9.11243 21.5768 9.37836 20.7285C9.64434 19.88 9.54482 18.9671 9.10238 18.1882C8.44999 17.0157 8.0651 15.7281 7.972 14.4081C7.87889 13.0878 8.07968 11.7636 8.56172 10.5203C9.04378 9.27696 9.7966 8.14161 10.7725 7.18734C11.7483 6.23305 12.9257 5.48097 14.2293 4.97982C15.5328 4.47866 16.9335 4.23965 18.3413 4.27833C19.7491 4.317 21.1325 4.63249 22.4028 5.20429C23.673 5.77608 24.8016 6.59141 25.7167 7.59749C26.6317 8.60353 27.313 9.7781 27.7173 11.0456L27.7175 11.0465C27.9782 11.8476 28.4424 12.5758 29.0688 13.168C29.6952 13.7601 30.4648 14.1985 31.3106 14.4458L31.3113 14.446C33.5111 15.0767 35.4131 16.3981 36.7017 18.188C37.99 19.9776 38.5877 22.128 38.3966 24.2807L38.3964 24.2827C38.2702 25.9536 37.6222 27.553 36.5327 28.8795L36.5324 28.8799C36.2306 29.2498 36.096 29.7193 36.1607 30.1848C36.2253 30.6502 36.4832 31.0698 36.874 31.3529C37.2646 31.6357 37.7569 31.7599 38.2429 31.7C38.7289 31.6401 39.172 31.4005 39.4735 31.031L39.4736 31.0308C40.9968 29.1597 41.9107 26.9107 42.1026 24.5574C42.3636 21.6018 41.5412 18.652 39.7741 16.2001C38.0072 13.7483 35.4029 11.9429 32.3968 11.0828C32.1263 11.0036 31.8817 10.8628 31.6845 10.6736C31.4872 10.4844 31.3435 10.2528 31.2654 10L31.2655 10L31.2645 9.99721C30.3492 7.22855 28.4804 4.82856 25.956 3.17595C23.4318 1.52343 20.3957 0.712081 17.3284 0.869182C14.261 1.02628 11.3358 2.14297 9.01606 4.04397C6.69627 5.94503 5.11432 8.52222 4.52282 11.3684C3.92655 14.1967 4.38866 17.1302 5.82644 19.6705Z"
                    fill="white"
                    stroke="white"
                    strokeWidth="0.3"
                  />
                </svg>

                <div className="course-details">
                  <h4 className="course-title">Excel Course</h4>
                  <ul className="course-detail-list">
                    <li>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z"
                          fill="#BBBBBB"
                        />
                        <path
                          d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z"
                          fill="#BBBBBB"
                        />
                        <path
                          d="M4.66797 11C5.22025 11 5.66797 10.5523 5.66797 10C5.66797 9.44772 5.22025 9 4.66797 9C4.11568 9 3.66797 9.44772 3.66797 10C3.66797 10.5523 4.11568 11 4.66797 11Z"
                          fill="#BBBBBB"
                        />
                        <path
                          d="M11.332 11C11.8843 11 12.332 10.5523 12.332 10C12.332 9.44772 11.8843 9 11.332 9C10.7797 9 10.332 9.44772 10.332 10C10.332 10.5523 10.7797 11 11.332 11Z"
                          fill="#BBBBBB"
                        />
                      </svg>
                      7 July
                    </li>
                    <li>
                      <svg
                        width="11"
                        height="14"
                        viewBox="0 0 11 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.532 3.316V3.568H10.62V5.044H8.424C8.292 5.848 8.04 6.49 7.668 6.97C7.308 7.438 6.792 7.78 6.12 7.996C5.448 8.2 4.578 8.302 3.51 8.302V9.436C3.51 10.096 3.648 10.618 3.924 11.002C4.212 11.386 4.692 11.578 5.364 11.578C6.588 11.578 7.2 10.888 7.2 9.508H9.09C9.078 10.72 8.748 11.638 8.1 12.262C7.464 12.874 6.54 13.18 5.328 13.18C4.116 13.18 3.186 12.844 2.538 12.172C1.902 11.5 1.584 10.558 1.584 9.346V6.88C2.916 6.88 3.894 6.844 4.518 6.772C5.142 6.688 5.604 6.52 5.904 6.268C6.216 6.016 6.42 5.608 6.516 5.044H0.828V3.568H6.606V3.316V1.966H0.828V0.471999H10.62V1.966H8.532V3.316Z"
                          fill="#BBBBBB"
                        />
                      </svg>
                      700
                    </li>
                  </ul>
                </div>
              </Link>
            </li> */}
          </ul>
        </div>

        <div
          className={`receipt-block dropdown-list contact-block ${isOpenContact ? "show" : ""
            }`}
        >
          <h3>
            Contact Us
            <svg
              onClick={toggleDropdownContact}
              className="right-arraow"
              xmlns="http://www.w3.org/2000/svg"
              width="110"
              height="110"
              viewBox="0 0 110 110"
              fill="none"
            >
              <path
                d="M105 5L5 105M5 5L105 105"
                stroke="#686D7B"
                strokeWidth="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </h3>
          <div>
            <select className="form-select" aria-label="Select Issues" required>
              <option defaultValue>Select Issues</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>

            <textarea
              name=""
              className="card-shadow support-textarea"
              id=""
              cols="30"
              rows="8"
              required
            ></textarea>

            <div className="btn-list">
              <Link className="support-btn" onClick={toggleSuccessBox}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M22.6704 10.0911L22.6704 10.0911L4.03858 0.840706C4.03856 0.840696 4.03854 0.840685 4.03852 0.840674C2.73383 0.19218 1.16669 0.753354 0.53718 2.08651L0.537177 2.08652C0.216618 2.76547 0.189711 3.55127 0.462988 4.25149C0.462994 4.25151 0.462999 4.25152 0.463005 4.25154L3.6816 12.5058L0.462986 20.7609L0.462856 20.7612C-0.0703864 22.1386 0.584181 23.7024 1.93277 24.252C2.23773 24.3763 2.56282 24.4409 2.89118 24.4424H2.89187C3.28906 24.4424 3.68099 24.3504 4.03837 24.1735L4.03853 24.1734L22.6703 14.9204L22.6703 14.9204C23.9729 14.2731 24.5138 12.6685 23.8854 11.3373C23.629 10.7942 23.2012 10.3549 22.6704 10.0911ZM3.18816 22.3819L3.18813 22.382C2.85627 22.5468 2.45417 22.4061 2.29095 22.0601L2.29094 22.0601C2.20763 21.8836 2.20064 21.6789 2.27182 21.4966L2.27185 21.4965L5.38887 13.5003H21.0776L3.18816 22.3819ZM3.18817 2.63212L21.0775 11.5112H5.38891L2.2719 3.51499L2.27191 3.51498L2.27107 3.51292C2.16301 3.24743 2.23071 2.94158 2.43726 2.75061L2.43734 2.7507L2.44149 2.74655C2.64054 2.54755 2.93937 2.50175 3.18522 2.63061L3.18521 2.63064L3.18817 2.63212Z"
                    fill="white"
                    stroke="white"
                    strokeWidth="0.3"
                  />
                  <line
                    x1="22.0992"
                    y1="11.2277"
                    x2="22.0992"
                    y2="14.3822"
                    stroke="white"
                    strokeWidth="0.3"
                  />
                  <line
                    x1="21.9492"
                    y1="12.322"
                    x2="22.4616"
                    y2="12.322"
                    stroke="white"
                    strokeWidth="0.3"
                  />
                  <line
                    x1="21.8961"
                    y1="11.2277"
                    x2="21.8961"
                    y2="13.3307"
                    stroke="white"
                    strokeWidth="0.3"
                  />
                </svg>{" "}
                Send
              </Link>
            </div>
          </div>
        </div>
      </div>




      <Modal
        show={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        className="payment-modal"
        centered
      >
        <Modal.Header className="p-4" closeButton>
          <Modal.Title>Pay Balance</Modal.Title>
        </Modal.Header>
        <Modal.Body className="user-select-none p-4">
          <form onSubmit={(e) => handlePayBalance(e)}>
            <div className="d-flex mb-3 me-3 col">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="49"
                viewBox="0 0 35 49"
                fill="none"
              >
                <path
                  d="M3.18182 0H35L31.8182 5.44444H21.4455C22.9727 7.02333 24.1182 8.87444 24.7864 10.8889H35L31.8182 16.3333H25.4545C25.0602 19.7273 23.3372 22.9077 20.5649 25.3586C17.7926 27.8095 14.1337 29.3871 10.1818 29.8356V29.9444H7.95455L27.0455 49H19.0909L0 29.9444V24.5H7.95455C13.5545 24.5 18.2 20.9611 18.9636 16.3333H0L3.18182 10.8889H18.0091C16.2273 7.67667 12.4091 5.44444 7.95455 5.44444H0L3.18182 0Z"
                  fill="#6A97CF"
                />
              </svg>

              <div className="user-form-data">
                <span>Balance</span>
                <h4>{userData?.balance}</h4>
              </div>
            </div>
            <input
              // value={balance}
              onChange={(e) => setBalance(e.target.value)}
              type="number"
              min="0"
              // max={userData?.balance}
              name="balance"
              id="balance"
              className="form-control"
              placeholder="Enter Amount To Proceed"
              required
            />
            {isError !== "" && <span className='error'>{isError}</span>}
            <div className="d-flex align-items-center justify-content-end">
              {/* <button
                className="btn btn-outline-secondary mt-4 me-2"
                onClick={() => setShowPaymentModal(false)}
              >
                Close
              </button> */}
              <button className="btn btn-outline-primary mt-4" type="submit">
                Pay Now
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        backdrop="static"
        keyboard={false}
        className="payment-modal"
        centered
      >
        <Modal.Body className="p-0 user-select-none">
          <div className="success-block w-100">
            <div className="exam-success1-tick-block">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="93"
                height="93"
                viewBox="0 0 93 93"
                fill="none"
              >
                <g clipPath="url(#clip0_727_17414)">
                  <path
                    d="M46.5 93C72.1812 93 93 72.1812 93 46.5C93 20.8188 72.1812 0 46.5 0C20.8188 0 0 20.8188 0 46.5C0 72.1812 20.8188 93 46.5 93Z"
                    fill="#6487C9"
                  />
                  <path
                    d="M34.6172 67.4763L58.5273 91.3864C78.3301 86.1056 92.9989 68.063 92.9989 46.4999C92.9989 46.0599 92.9989 45.6198 92.9989 45.1798L74.2229 27.8706L34.6172 67.4763Z"
                    fill="#466EB6"
                  />
                  <path
                    d="M47.6724 56.9149C49.726 58.9685 49.726 62.489 47.6724 64.5427L43.4184 68.7966C41.3648 70.8502 37.8443 70.8502 35.7907 68.7966L17.1613 50.0206C15.1077 47.9669 15.1077 44.4464 17.1613 42.3928L21.4153 38.1389C23.4689 36.0852 26.9894 36.0852 29.043 38.1389L47.6724 56.9149Z"
                    fill="white"
                  />
                  <path
                    d="M63.956 24.4969C66.0097 22.4433 69.5302 22.4433 71.5838 24.4969L75.8377 28.7508C77.8914 30.8045 77.8914 34.325 75.8377 36.3786L43.5665 68.5032C41.5128 70.5568 37.9923 70.5568 35.9387 68.5032L31.6848 64.2492C29.6311 62.1956 29.6311 58.6751 31.6848 56.6215L63.956 24.4969Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_727_17414">
                    <rect width="93" height="93" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="53"
                height="25"
                viewBox="0 5 53 25"
                fill="none"
                className="blue-triangle"
              >
                <path
                  d="M24.6814 23.6119C25.7559 24.4317 27.2459 24.4317 28.3205 23.6119L51.0863 6.24485C53.3686 4.50375 52.1373 0.859646 49.2667 0.859646H3.73516C0.864535 0.859646 -0.36674 4.50374 1.9156 6.24484L24.6814 23.6119Z"
                  fill="#DDEEFD"
                />
              </svg>
            </div>
            <div className="exam-success-text-block">
              <div className="exam-course-title">
                Your Payment of has been Successfully Completed...!
              </div>

              {/* <div className="exam-text mt-3 text-center">
                Congratulations You have scored{" "}
                {result ? (
                  <>
                    <Link className="d-block">"{result?.examMarks}" Marks</Link>
                  </>
                ) : (
                  <>
                    <Link className="d-block">Loading ...</Link>
                  </>
                )}
                & your certificate is now available
              </div> */}

              <div className="btn-list text-center mt-5">
                <a
                  className="btn support-btn"
                  onClick={() => setShowSuccessModal(false)}
                >
                  Close
                </a>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showFailureModal}
        className="payment-modal"
        onHide={() => setShowFailureModal(false)}
        centered
      >
        <Modal.Body className="p-0 user-select-none">
          <div className="success-block w-100">
            <div className="exam-success-tick-block red-bg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="147"
                height="146"
                viewBox="0 0 147 146"
                fill="none"
              >
                <path
                  d="M125.467 145.699H21.4348C5.52115 145.699 -4.82914 129.083 2.28758 114.961L54.3033 11.7412C62.1924 -3.91374 84.7086 -3.91374 92.5977 11.7412L144.613 114.96C151.731 129.083 141.38 145.699 125.467 145.699Z"
                  fill="url(#paint0_linear_727_20114)"
                />
                <path
                  d="M125.467 145.699H21.4348C5.52115 145.699 -4.82914 129.083 2.28758 114.961L54.3033 11.7412C62.1924 -3.91374 84.7086 -3.91374 92.5977 11.7412L144.613 114.96C151.731 129.083 141.38 145.699 125.467 145.699Z"
                  fill="#EC654D"
                />
                <path
                  d="M126.04 145.7H112.84L68.2913 122.781C66.8914 122.1 65.8163 118.688 64.9913 116.232C64.9913 109.893 63.8656 83.9226 63.3414 69.5757C62.8172 55.2317 61.6914 52.1771 61.6914 45.8382C63.3414 39.2899 68.2913 40.927 68.2913 40.1085C69.9412 40.1084 71.8791 39.3091 74.0855 39.3091C76.2919 39.3091 81.6714 39.2899 83.9659 42.564C84.1647 42.7812 121.039 84.2648 135.94 99.043L144.189 114.595C152.439 129.329 140.89 145.7 126.04 145.7Z"
                  fill="#EB4335"
                />
                <path
                  d="M113.898 145.698H92.4734L67.9121 121.329C66.2789 119.9 65.4609 118.234 65.4609 116.327C65.4609 114.341 66.2789 112.652 67.9121 111.263C69.5452 109.874 71.5298 109.18 73.8631 109.18C75.9168 109.18 77.694 109.874 79.1917 111.263L113.898 145.698Z"
                  fill="#EB4335"
                />
                <path
                  d="M61.8477 45.7517C61.8477 43.6891 63.0015 42.0959 65.3107 40.9736C67.6189 39.8513 70.6084 39.2896 74.2792 39.2896C77.9499 39.2896 80.6467 39.8739 82.3663 41.0415C84.0854 42.2091 84.9471 43.7788 84.9471 45.7517C84.9471 52.2165 84.7628 55.2194 84.4024 69.8493C84.0382 84.4797 83.8582 89.0898 83.8582 95.5519C83.8582 96.9004 82.8198 97.9559 80.746 98.7177C78.6688 99.4797 76.5134 99.8612 74.2796 99.8612C67.7359 99.8612 64.4633 98.4259 64.4633 95.5519C64.4633 89.0898 64.027 84.4797 63.1557 69.8493C62.283 55.2191 61.8477 52.2162 61.8477 45.7517Z"
                  fill="white"
                />
                <circle cx="73.3943" cy="120.151" r="8.24981" fill="white" />
                <defs>
                  <linearGradient
                    id="paint0_linear_727_20114"
                    x1="36.8434"
                    y1="62.3159"
                    x2="203.104"
                    y2="229.885"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#FFB92D" />
                    <stop offset="1" stopColor="#F59500" />
                  </linearGradient>
                </defs>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="38"
                className="blue-triangle"
                viewBox="0 0 80 38"
                fill="none"
              >
                <path
                  d="M38.0229 37.1732C39.1548 38.166 40.8473 38.166 41.9792 37.1732L78.1604 5.43969C80.2417 3.61427 78.9506 0.184277 76.1822 0.184277H3.8199C1.05154 0.184277 -0.239513 3.61427 1.84175 5.43969L38.0229 37.1732Z"
                  fill="#FFCDC5"
                />
              </svg>
            </div>
            <div className="exam-success-text-block">
              <div className="exam-course-title">
                Your Payment has been Unsuccessful...!
              </div>

              {/* <div className="exam-text mt-3 text-center">
                If you click the button below your exam will end and you will
                get certificate based on answers you have appeared till now...!
              </div> */}

              <div className="btn-list text-center mt-5">
                <Link
                  className="end-btn"
                  onClick={() => setShowFailureModal(false)}
                >
                  Close
                </Link>
                <Link
                  className="end-btn ms-2"
                  onClick={(e) => handlePayBalance(e)}
                >
                  Retry Payment
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="14"
                    viewBox="0 0 15 14"
                    fill="none"
                    className="ms-2"
                  >
                    <path
                      d="M8.70071 13.6584C8.60108 13.5501 8.52205 13.4214 8.46813 13.2798C8.4142 13.1382 8.38645 12.9864 8.38645 12.833C8.38645 12.6797 8.4142 12.5279 8.46813 12.3863C8.52205 12.2447 8.60108 12.116 8.70071 12.0077L12.2281 8.16599L1.07152 8.15782C0.787333 8.15782 0.514787 8.03491 0.313839 7.81613C0.11289 7.59734 0 7.30061 0 6.9912C0 6.6818 0.11289 6.38506 0.313839 6.16628C0.514787 5.94749 0.787333 5.82458 1.07152 5.82458L12.2303 5.83275L8.70071 1.99224C8.49965 1.77349 8.38664 1.47674 8.38654 1.16727C8.38644 0.857799 8.49926 0.560961 8.70017 0.342056C8.90109 0.12315 9.17365 0.000109468 9.45789 7.30087e-08C9.74213 -0.000109322 10.0148 0.122722 10.2158 0.341473L14.0583 4.52497C14.3568 4.84997 14.5937 5.23582 14.7553 5.66048C14.9168 6.08514 15 6.54029 15 6.99995C15 7.45961 14.9168 7.91476 14.7553 8.33943C14.5937 8.76409 14.3568 9.14993 14.0583 9.47493L10.2158 13.6584C10.0149 13.8771 9.7424 14 9.45827 14C9.17414 14 8.90165 13.8771 8.70071 13.6584Z"
                      fill="white"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>




    </>
  );
};

export default Profile;
